// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.media-player__video {
  margin-top: 2rem;
  display: block;
}
.media-player__video video {
  width: 100%;
}
.media-player__controls {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.media-player__controls button {
  background-color: transparent;
  border: none;
  width: 15%;
  cursor: pointer;
}
.media-player__controls button .anticon {
  font-size: 2rem;
  color: #f3ab58;
}
.media-player__time {
  width: 60%;
}
.media-player__time-info {
  display: flex;
  justify-content: space-between;
}
.media-player__volume {
  display: flex;
  flex-direction: column;
  width: 15%;
}
.media-player__volume .anticon {
  margin-top: 0.5rem;
}
.media-player input[type="range"] {
  -webkit-appearance: none;
  margin-right: 15px;
  height: 7px;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 5px;
  background-image: linear-gradient(#f3ab58, #f3ab58);
  background-size: 0%;
  background-repeat: no-repeat;
}
.media-player input[type="range"].media-player__time-slider {
  width: 100%;
}
.media-player input[type="range"].media-player__volume-slider {
  background-size: 50%;
}
.media-player input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none;
  height: 15px;
  width: 15px;
  border-radius: 50%;
  background: #f3ab58;
  cursor: pointer;
  box-shadow: 0 0 2px 0 #555;
}
.media-player input[type=range]::-webkit-slider-runnable-track {
  -webkit-appearance: none;
  box-shadow: none;
  border: none;
  background: transparent;
}
.media-player__captions {
  margin-bottom: 0;
  text-align: center;
  font-size: 1rem;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/components/MediaPlayer/style.less"],"names":[],"mappings":"AACE;EACE,gBAAA;EACA,cAAA;AAAJ;AAFE;EAII,WAAA;AACN;AAGE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AADJ;AAFE;EAMI,6BAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;AADN;AARE;EAWM,eAAA;EACA,cAAA;AAAR;AAKE;EACE,UAAA;AAHJ;AAII;EACE,aAAA;EACA,8BAAA;AAFN;AAME;EACE,aAAA;EACA,sBAAA;EACA,UAAA;AAJJ;AACE;EAKI,kBAAA;AAHN;AApCA;EA4CI,wBAAA;EACA,kBAAA;EACA,WAAA;EACA,oCAAA;EACA,kBAAA;EACA,mDAAA;EACA,mBAAA;EACA,4BAAA;AALJ;AA9CA;EAuDI,WAAA;AANJ;AAjDA;EA2DI,oBAAA;AAPJ;AApDA;EA+DI,wBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,0BAAA;AARJ;AA7DA;EAyEI,wBAAA;EACA,gBAAA;EACA,YAAA;EACA,uBAAA;AATJ;AAYE;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AAVJ","sourcesContent":[".media-player {\n  &__video {\n    margin-top: 2rem;\n    display: block;\n    video {\n      width: 100%;\n    }\n  }\n\n  &__controls {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    button {\n      background-color: transparent;\n      border: none;\n      width: 15%;\n      cursor: pointer;\n      .anticon {\n        font-size: 2rem;\n        color: @beey-orange;\n      }\n    }\n  }\n\n  &__time {\n    width: 60%;\n    &-info {\n      display: flex;\n      justify-content: space-between;\n    }\n  }\n\n  &__volume {\n    display: flex;\n    flex-direction: column;\n    width: 15%;\n    .anticon {\n      margin-top: 0.5rem;\n    }\n  }\n\n  input[type=\"range\"] {\n    -webkit-appearance: none;\n    margin-right: 15px;\n    height: 7px;\n    background: rgba(255, 255, 255, 0.6);\n    border-radius: 5px;\n    background-image: linear-gradient(@beey-orange, @beey-orange);\n    background-size: 0%;\n    background-repeat: no-repeat;\n  }\n\n  input[type=\"range\"].media-player__time-slider {\n    width: 100%;\n  }\n\n  input[type=\"range\"].media-player__volume-slider {\n    background-size: 50%;\n  }\n\n  input[type=\"range\"]::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    height: 15px;\n    width: 15px;\n    border-radius: 50%;\n    background: @beey-orange;\n    cursor: pointer;\n    box-shadow: 0 0 2px 0 #555;\n  }\n\n  input[type=range]::-webkit-slider-runnable-track {\n    -webkit-appearance: none;\n    box-shadow: none;\n    border: none;\n    background: transparent;\n  }\n\n  &__captions {\n    margin-bottom: 0;\n    text-align: center;\n    font-size: 1rem;\n    font-weight: 600;\n  }\n}\n\n@display-sm: ~\"only screen and (min-width:576px) \";@display-md: ~\"only screen and (min-width:768px)\";@display-lg: ~\"only screen and (min-width:992px)\";@display-xl: ~\"only screen and (min-width:1200px)\";@display-xxl: ~\"only screen and (min-width:1680px)\";@font-family: 'Open Sans', sans-serif;@font-size-base: 15px;@font-size-lg: @font-size-base + 2px;@font-size-sm: @font-size-base - 2px;@white: #fff;@beey-orange: #f3ab58;@beey-orange-darken: #f29f40;@beey-yellow-light: #fef9e9;@beey-blue: #698efc;@beey-blue-light: #82a1fc;@primary-color: @beey-orange-darken;@link-color: @beey-orange-darken;@text-color: #444;@text-color-secondary: #888;@heading-color: #303030;@header-height: 5rem;@header-height-sm: 3rem;@header-line-height: 2rem;@playback-height: 65px;@color-error: #95190c;@text-primary-disabled: #999;@text-secondary: #000000;@text-secondary-dimmed: #666;@text-heading1: #000000;@font-weight-semi-bold: 600;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
